import { useAuth } from '#imports'
import get from 'lodash.get'
import { PROJECT_ROLE, STAFF_ROLES } from "@/helpers/ConstantHelper"

/**
 * Composable để kiểm tra quyền của user.
 * Tự động lấy session và cung cấp hàm `can()`.
 */
export const usePermissions = () => {
  const { data: session } = useAuth()
  const user = session?.value?.user ?? null

  const can = permission => {
    const userPermissions = get(session.value, 'user.permissions', [])

    return userPermissions.includes(permission)
  }

  const hasInProject = project => {
    const staffs = project.staffs ?? []
    
    return !!staffs.find(staff => Number(staff?.id) === Number(user?.id))
  }

  const isProjectLeader = project =>
  {
    const staffs = project.staffs ?? []
    const staff = staffs.find(staff => Number(staff.id) === Number(user.id))
    
    return staff?.type === PROJECT_ROLE.LEADER
  }

  const isStaff = () => {
    return user.role_id === STAFF_ROLES.STAFF
  }

  const isAdmin = () => {
    return user.role_id === STAFF_ROLES.SUPERADMIN
  }

  const isDirector = () => {
    return user.role_id === STAFF_ROLES.DIRECTOR
  }

  const isDepartmentHead = () => {
    return user.role_id === STAFF_ROLES.DEPARTMENT_HEAD
  }

  const isDeputyHead = () => {
    return user.role_id === STAFF_ROLES.DEPUTY_HEAD
  }

  return { can, isDirector, isDepartmentHead, isDeputyHead, hasInProject, isProjectLeader, userId: user?.id, isStaff, isAdmin }
}
